import usePrivateAxios from "@/common/api/usePrivateAxios";
import { MaintenanceRequiredDocumentValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateEstablishmentCompanyMaintenanceRequiredDocumentsProps {
  establishmentCompanyId?: string;
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentCompanyMaintenanceRequiredDocuments = ({
  establishmentCompanyId,
  onSuccess,
  onError,
}: UseUpdateEstablishmentCompanyMaintenanceRequiredDocumentsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyMaintenanceRequiredDocuments'],
    mutationFn: (data: MaintenanceRequiredDocumentValidationSchema) => {
      const payload = {
        maintenance_required_documents_attributes: [
          {
            id: data.id,
            file_attachment_attributes: data.file_attachment_attributes?.blob_id ? {
              blob_id: data.file_attachment_attributes?.blob_id,
            } : undefined,
            valid_until: data.valid_until,
            issue_date: data.issue_date,
          }
        ],
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      })
    },
    onSuccess,
    onError,
  })
}
